import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  backendErrors: {},
  // `{ uuid, businessName }` of the account open on the edit page, so the
  // breadcrumb can name it. The breadcrumb otherwise looks the account up
  // in the user's metadata and the Accounts list, and a just-created
  // account (or one past the list's first page) is in neither — the
  // crumb stayed a loading skeleton for good.
  editedAccount: null,
};

export const accountEditingSlice = createSlice({
  name: 'accountEditing',
  initialState,
  reducers: {
    setAccountBackendErrors: (state, action) => {
      state.backendErrors = action.payload;
    },
    clearAccountBackendErrors: (state) => {
      state.backendErrors = {};
    },
    setEditedAccount: (state, action) => {
      state.editedAccount = action.payload;
    },
    clearEditedAccount: (state) => {
      state.editedAccount = null;
    },
  },
});

export const {
  setAccountBackendErrors,
  clearAccountBackendErrors,
  setEditedAccount,
  clearEditedAccount,
} = accountEditingSlice.actions;

export default accountEditingSlice.reducer;